import React from 'react'
import { MainLayout } from "./src/layouts/MainLayout";
require("prismjs/themes/prism-tomorrow.css");
require("prismjs/plugins/line-numbers/prism-line-numbers.css");

export function wrapPageElement({ element, props }) {
  return <MainLayout {...props}>{element}</MainLayout>
}

